import styled from 'styled-components';
import { Input, Pagination, Select, Button as AntButton } from 'antd';
import { colors } from '@/utils/colorSystem';

export const TableWrapper = styled.div`
    background: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? theme.colors.background.secondary : '#ffffff';
    }};
    border-radius: ${({ $radius }) => ($radius != null ? `${$radius}px` : '12px')};
    padding: 0;
    border: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return `1px solid ${isDark ? '#2C2C2C' : '#E5E5E5'}`;
    }};
    overflow: hidden;
    @media (max-width: 1024px) {
        border-radius: ${({ $radius }) => ($radius != null ? `${$radius}px` : '32px')};
    }

    @media (max-width: 768px) {
        border-radius: ${({ $radius }) => ($radius != null ? `${$radius}px` : '24px')};
        margin-top: ${({ $topMargin }) => ($topMargin ? '20px' : '0')};
    }

    @media (max-width: 480px) {
        border-radius: ${({ $radius }) => ($radius != null ? `${$radius}px` : '20px')};
        margin-top: ${({ $topMargin }) => ($topMargin ? '16px' : '0')};
    }
`;

export const TableSelectDropdown = styled.div`
    .ant-select-item {
        font-size: 14px !important;
        font-weight: 500 !important;
        font-family: var(--font-family-geist) !important;
        line-height: 1.5 !important;

        .ant-select-item-option-content {
            font-size: 14px !important;
            font-weight: 500 !important;
            font-family: var(--font-family-geist) !important;
        }
    }
`;

export const TableContent = styled.div`
    padding: ${({ $noHeader }) => ($noHeader ? '16px' : '0')};

    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: thin;
    scrollbar-color: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#2C2C2C #1A1A1A' : '#E5E5E5 #F5F5F5';
    }};

    &::-webkit-scrollbar {
        height: 8px;
    }

    &::-webkit-scrollbar-track {
        background: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#1A1A1A' : '#F5F5F5';
    }};
        border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb {
        background: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#2C2C2C' : '#E5E5E5';
    }};
        border-radius: 4px;

        &:hover {
            background: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#3C3C3C' : '#D5D5D5';
    }};
        }
    }

    @media (max-width: 1024px) {
        padding: 0 20px 20px 20px;
    }

    @media (max-width: 768px) {
        padding: 0 16px 16px 16px;
    }

    @media (max-width: 480px) {
        padding: 0 12px 12px 12px;
    }
`;

export const StyledTable = styled.table`
    width: 100%;
    min-width: 800px;
    border-collapse: collapse;
    border-radius: 0;
    overflow: visible;
    background: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? theme.colors.background.secondary : '#ffffff';
    }};

    @media (max-width: 1024px) {
        min-width: 700px;
    }

    @media (max-width: 768px) {
        min-width: 600px;
    }

    @media (max-width: 480px) {
        min-width: 500px;
    }
`;



export const TableHeaderCell = styled.th`
    padding: 13px 24px;
    text-align: ${({ $align }) => ($align === 'right' ? 'right' : $align === 'left' ? 'left' : 'left')};
    font-size: 12px;
    font-weight: 500;
    color: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#ffffff' : '#292929';
    }};
    border-bottom: 1px solid
        ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#2C2C2C' : '#E5E5E5';
    }};
    font-family: var(--font-family-geist);
    white-space: nowrap;
    position: sticky;
    top: 0;
    z-index: 10;

    &:first-child {
        padding-left: ${({ theme }) => theme.spacing.lg};
    }

    &:last-child {
        padding-right: ${({ theme }) => theme.spacing.lg};
    }

    @media (max-width: 1024px) {
        padding: 14px 20px;
        font-size: 13px;

        &:first-child {
            padding-left: 20px;
        }

        &:last-child {
            padding-right: 20px;
        }
    }

    @media (max-width: 768px) {
        padding: 12px 16px;
        font-size: 12px;

        &:first-child {
            padding-left: 16px;
        }

        &:last-child {
            padding-right: 16px;
        }
    }

    @media (max-width: 480px) {
        padding: 10px 12px;
        font-size: 11px;

        &:first-child {
            padding-left: 12px;
        }

        &:last-child {
            padding-right: 12px;
        }
    }
`;

export const TableBody = styled.tbody``;

export const TableEmptyCell = styled.td`
    text-align: center !important;
    padding: 48px 24px !important;
    border-bottom: none !important;
    vertical-align: middle;
    color: ${({ theme }) =>
        theme.colors.background.default === '#141414' ? 'rgba(255,255,255,0.45)' : 'rgba(0,0,0,0.45)'};
    .ant-empty-description {
        color: inherit;
    }
    .anticon {
        color: inherit;
    }
`;

export const TableRow = styled.tr`
    border-bottom: 1px solid
        ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#2C2C2C' : '#E5E5E5';
    }};
    cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};

    &:last-child {
        border-bottom: none;

        td:first-child {
            border-bottom-left-radius: 12px;
        }

        td:last-child {
            border-bottom-right-radius: 12px;
        }
    }

    &:hover {
        background: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#2C2C2C' : '#FAFAFA';
    }};
    }
`;

export const TableCell = styled.td`
    padding: 16px 24px;
    font-size: 14px;
    font-weight: 500;
    color:  ${colors.neutral[900]};
    font-family: var(--font-family-geist);
    text-align: ${({ $align }) => ($align === 'right' ? 'right' : $align === 'left' ? 'left' : 'left')};
    white-space: nowrap;
    width: ${({ $width }) => ($width ? $width : 'auto')};

    @media (max-width: 1024px) {
        padding: 14px 20px;
        font-size: 13px;
    }

    @media (max-width: 768px) {
        padding: 12px 16px;
        font-size: 12px;

    }

    @media (max-width: 480px) {
        padding: 10px 12px;
        font-size: 11px;

   
    }
`;

export const TablePagination = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 24px;
    margin-bottom: 26px;
    padding-top: 16px;
    padding-right: ${({ theme }) => theme.spacing.lg};
    border-top: 1px solid
        ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#2C2C2C' : '#E5E5E5';
    }};
    position: sticky;
    left: 0;
    background: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? theme.colors.background.secondary : '#ffffff';
    }};
    z-index: 5;
    width: 100%;
    box-sizing: border-box;

    @media (max-width: 1024px) {
        padding-left: 20px;
    }

    @media (max-width: 768px) {
        padding-left: 16px;
    }

    @media (max-width: 480px) {
        padding-left: 12px;
    }
`;

export const StyledPagination = styled(Pagination)`
    .ant-pagination {
        font-family: var(--font-family-geist);
    }

    .ant-pagination-item {
        border-radius: 6px;
        border: 1px solid
            ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#2C2C2C' : '#E5E5E5';
    }};
        background: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? theme.colors.background.secondary : '#ffffff';
    }};

        a {
            color: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#ffffff' : '#292929';
    }};
            font-size: 14px;
            font-weight: 500;
        }

        &:hover {
            border-color: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#ffffff' : theme.colors?.primary ?? '#1890ff';
    }};
            background: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#2C2C2C' : '#FAFAFA';
    }};

            a {
                color: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#ffffff' : theme.colors?.primary ?? '#1890ff';
    }};
            }
        }

        &.ant-pagination-item-active {
            border-color: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#ffffff' : theme.colors?.primary ?? '#1890ff';
    }};
            background: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#ffffff' : theme.colors?.primary ?? '#1890ff';
    }};

            a {
                color: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#000000' : '#ffffff';
    }};
            }

            &:hover {
                border-color: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#ffffff' : theme.colors?.primary ?? '#1890ff';
    }};
                background: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#ffffff' : theme.colors?.primary ?? '#1890ff';
    }};
            }
        }
    }

    .ant-pagination-prev,
    .ant-pagination-next {
        border-radius: 6px;
        border: 1px solid
            ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#2C2C2C' : '#E5E5E5';
    }};
        background: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? theme.colors.background.secondary : '#ffffff';
    }};

        .ant-pagination-item-link {
            color: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#ffffff' : '#292929';
    }};
        }

        &:hover:not(.ant-pagination-disabled) {
            border-color: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#ffffff' : theme.colors?.primary ?? '#1890ff';
    }};
            background: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#2C2C2C' : '#FAFAFA';
    }};

            .ant-pagination-item-link {
                color: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#ffffff' : theme.colors?.primary ?? '#1890ff';
    }};
            }
        }

        &.ant-pagination-disabled {
            opacity: 0.5;
            cursor: not-allowed;
        }
    }

    .ant-pagination-options {
        .ant-select {
            .ant-select-selector {
                border-radius: 6px;
                border: 1px solid
                    ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#2C2C2C' : '#E5E5E5';
    }};
                background: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? theme.colors.background.secondary : '#ffffff';
    }};
                color: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#ffffff' : '#292929';
    }};
            }
        }
    }

    .ant-pagination-total-text {
        color: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#ffffff' : '#292929';
    }};
        font-size: 14px;
        font-weight: 400;
        font-family: var(--font-family-geist);
    }
`;
